import './filter.less'

import {Icon} from '@codeurs/front'
import React, {useState} from 'react'
import {t} from 'util/i18n'
import {style} from 'util/style'

const styles = style('filter', ['dropdown', 'clear'])

export const Filter: React.FC<{
	text?: string
	placeholder: string
	choices: Array<{key: string; label: string}>
	value: string
	onChange: (value: string) => void
}> = ({text, placeholder, choices, value, onChange}) => {
	const [open, setOpen] = useState(false)
	const activeLabel = choices.find(choice => choice.key === value)

	return (
		<a className={styles()} onClick={() => setOpen(!open)}>
			<div className={styles('label')}>
				{text && <p className={styles('label-text')}>{text}</p>}
				<p className={styles('label-placeholder')}>
					{activeLabel?.label || placeholder}
				</p>
				<span className={styles('label-icon')}>
					<Icon icon="chevron-down-wide" />
				</span>
			</div>
			<FilterDropdown
				open={open}
				choices={choices.filter(choice => choice.key !== value)}
				value={value}
				onChange={onChange}
			/>
		</a>
	)
}

export const FilterDropdown: React.FC<{
	open: boolean
	choices: Array<{key: string; label: string}>
	value: string
	onChange: (value: string) => void
}> = ({open, choices, value, onChange}) => {
	if (!choices || choices.length === 0) return null

	return (
		<div className={styles.dropdown().is({open})}>
			<div className={styles.dropdown('flyout')}>
				{choices.map(choice => (
					<a
						className={styles.dropdown('item')}
						key={choice.key}
						onClick={() => onChange(choice.key)}
					>
						{choice.label}
					</a>
				))}
			</div>
		</div>
	)
}

export const FilterClear: React.FC<{
	text?: string
	onClear: () => void
}> = ({text, onClear}) => {
	return (
		<a className={styles.clear()} onClick={onClear}>
			{text ? text : t('filters.clear')}
		</a>
	)
}
